import { generateApiPath } from "@routes/generatePath.ts";
import type { IExtractApiParams } from "@routes/types";

const pathBase = `/medical-service-provider/assign-to-doctor/:mspId`;

export type IPathBaseParams = IExtractApiParams<typeof pathBase>;

export const assignToDoctor = {
  post: (params: IPathBaseParams) => generateApiPath(pathBase, params),
};
